import { ChangeDetectionStrategy, Component, inject, input } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';

@Component({
  selector: 'dmb-qr-code',
  templateUrl: './qr-code.component.html',
  styleUrls: ['./qr-code.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class QrCodeComponent {
  private sanitizer = inject(DomSanitizer);

  qrCode = input.required({
    transform: (val: string) => this.sanitizer.bypassSecurityTrustUrl(`data:image/PNG;base64,${val}`),
  });
}
